export const REPORT_GROUPS = [
  { group: "Vendas", items: [
    { k: "vendas-periodo", label: "Vendas por período" },
    { k: "vendas-produto", label: "Vendas por produto" },
    { k: "vendas-categoria", label: "Vendas por categoria" },
    { k: "mais-vendidos", label: "Produtos mais vendidos" },
    { k: "formas-pagamento", label: "Vendas por forma de pagamento" },
    { k: "operador", label: "Vendas por operador" },
  ] },
  { group: "Financeiro", items: [
    { k: "faturamento", label: "Faturamento" },
    { k: "lucro", label: "Lucro estimado" },
    { k: "ticket-medio", label: "Ticket médio" },
    { k: "canceladas", label: "Vendas canceladas" },
    { k: "descontos", label: "Descontos concedidos" },
    { k: "caixa", label: "Relatório de caixa" },
  ] },
  { group: "Operação", items: [
    { k: "comandas", label: "Relatório de comandas" },
    { k: "mesas", label: "Relatório de mesas" },
    { k: "delivery", label: "Relatório de delivery" },
    { k: "estacionamento", label: "Relatório de estacionamento" },
    { k: "tickets", label: "Relatório de tickets" },
  ] },
  { group: "Cadastros", items: [
    { k: "clientes", label: "Relatório de clientes" },
    { k: "estoque", label: "Relatório de estoque" },
  ] },
];

export const REPORTS = REPORT_GROUPS.flatMap((g) => g.items);
export const reportLabel = (k) => REPORTS.find((r) => r.k === k)?.label || k;
